(function () {
    'use strict';

    angular
        .module('plagiat2017App')
        .controller('TagGroupAddController', TagGroupAddController);
    
    TagGroupAddController.$inject = ['TagsService', 'ModalService',
        '$localStorage', '$state', '$stateParams'];

    function TagGroupAddController(TagsService, ModalService,
        $localStorage, $state, $stateParams) {
        var vm = this;
        vm.pending = false;
        vm.activeTab = 'tags';
        
        vm.obj = {};
        vm.saveOrUpdate = saveOrUpdate;

        this.$onInit = function () {
            vm.pending = true;

            if ($stateParams.id) {
                TagsService.getTagGroupForEditing($stateParams.id).then(function (obj) {
                    vm.obj = obj.data;
                });
            }
            vm.pending = false;
        };
    
        function saveOrUpdate() {
            TagsService
                .saveOrUpdateTagGroup(vm.obj)
                .then(function () {
                    vm.obj = null;
                    ModalService.showSuccessModal("global.messages.success.label");
                    $state.go('tags-list');
                    $stateParams.id = null;
                }, function (errorResponse) {
                    ModalService.showErrorModal(errorResponse);
                });
        }

    }
})();
